const LINKEDIN_URL = 'https://www.linkedin.com/in/vinoth-trevor-skanthavarathan-01b6ba141/';

const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="min-h-screen flex flex-col justify-center px-6 md:px-12 lg:px-24 pt-20"
      style={{ backgroundColor: '#3A3D42' }}
    >
      <div className="max-w-3xl hero-stagger">
        <p className="eyebrow" data-testid="hero-eyebrow">
          For founders already in motion.
        </p>

        <h1 className="headline mt-6" data-testid="hero-headline">
          You&rsquo;re not failing.<br />
          You&rsquo;re operating without a decision layer.
        </h1>

        <p className="subhead mt-8" data-testid="hero-subhead">
          Your pitch deck says one thing. Your product says another. Your cofounder&rsquo;s priorities say a third. Every week that gap goes unnamed costs you runway and decisions you cannot walk back.
        </p>
        <p className="subhead mt-4" data-testid="hero-subhead-2">
          I find the gap. I name it. Then we remove it.
        </p>

        <div className="mt-10">
          <a
            href={LINKEDIN_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-cta-button"
            className="cta-button"
          >
            Find out what you&rsquo;re not seeing &rarr;
          </a>
        </div>

        <p className="credential mt-5" data-testid="hero-credential">
          Co-founder and CEO of a deep-tech company acquired by Snap Inc. in 2022.
        </p>
      </div>
    </section>
  );
};

export default Hero;
